import {API_CRM_AUTHORIZE_CLARIO, API_CRM_GET_REFRESH_TOKEN_CLARIO} from '../constants/api';
import handleResponse from '../foundations/utils/handleResponse';
import {getRequestHeaders} from '../foundations/utils/authHeader';
import {Config} from '../interfaces/zchat';
import {AuthorizeResponse} from '../interfaces/api';
import CommonClient from './commonClient';
import {EventEmitter} from 'events';

declare var API_KEY_CLARIO: string;

export default class ClarioClient extends CommonClient {
  private static instance: ClarioClient;

  constructor(config: Config, eventEmitter: EventEmitter) {
    super(config, eventEmitter);
  }

  // Authorize method with exponential backoff retry
  public async authorize(): Promise<void> {
    return await this.retryableFetch((this.authorizeApiCall).bind(this));
  }

  private async authorizeApiCall(): Promise<AuthorizeResponse> {
    let deviceId = this.roomConfig.deviceId || await ClarioClient.getDeviceId();
    const requestBody = {
      api_key: API_KEY_CLARIO,
      device_id: deviceId,
    };

    const requestOptions: RequestInit = {
      method: 'POST',
      headers: getRequestHeaders(),
      credentials: 'include',
      body: JSON.stringify(requestBody)
    };

    return fetch(API_CRM_AUTHORIZE_CLARIO, requestOptions)
      .then(handleResponse)
      .then(this.processingAuthorizeResponse.bind(this))
      .catch((error) => this.handleError(error, API_CRM_AUTHORIZE_CLARIO, 'auth', {...this.chatConfig, ...this.roomConfig}));
  }

  public async getRefreshTokenApiCall(): Promise<void> {
    const getRefreshTokenApiLink = `${API_CRM_GET_REFRESH_TOKEN_CLARIO}/${this.roomId}/`;
    let requestOptions: RequestInit = {
      method: 'POST',
      headers: getRequestHeaders(this.accessToken),
      credentials: 'include',
    };

    return fetch(getRefreshTokenApiLink, requestOptions)
      .then(handleResponse)
      .then(resp => Promise.resolve(resp))
      .catch(error => this.handleError(error, getRefreshTokenApiLink, 'refresh-token'));
  }

  public static getInstance(config: Config, eventEmitter: EventEmitter): ClarioClient {
    if (!ClarioClient.instance) {
      ClarioClient.instance = new ClarioClient(config, eventEmitter);
    }

    return ClarioClient.instance;
  }
}

